import '@/modules/product-variants';
import QuickAddModal from '@/modules/quick-add';

if (document.getElementsByTagName('quick-add-modal')) {
    customElements.define('quick-add-modal', QuickAddModal);
}